import { Grid, Typography, Checkbox } from '@mui/material';

import { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';

import styles from './MappingApprovalDailog.module.scss';

interface IMappingConfirmationDailog {
	cancelClicked?: any;
	submitClicked?: any;
}

const MappingApprovalDailog = (props: IMappingConfirmationDailog) => {
	const { cancelClicked, submitClicked } = props;
	const { checkBoxColor, checkBoxCheckedColor } = styles;
	const [selectedCheckBox, setSelectedCheckBox] = useState<number[]>([]);

	const handleCheckBox = (
		index: number,
		event: React.ChangeEvent<HTMLInputElement>,
	) => {
		if ((event.target as HTMLInputElement).checked) {
			setSelectedCheckBox((res) => [...res, index]);
		} else {
			setSelectedCheckBox((res) => res.filter((element) => element !== index));
		}
	};

	const item = {
		id: 1,
		value:
			'I understand, that upon acceptance, this Regulation will be added to the Regulation Library at which time only [Admin Level Title] will be able to make edits or updates.',
	};

	return (
		<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
			<Grid container direction="column" gap="12px">
				<Typography className={styles['modal-heading']}>
					Approval Confirmation
				</Typography>
				<Grid
					container
					direction="row"
					alignItems="normal"
					className={styles['stack-background']}
				>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						display="flex"
						alignItems="flex-start"
						key={item.id}
						className={styles['modal-sub-text-grid']}
					>
						<Checkbox
							size="small"
							data-testid="modal-checkbox"
							checked={selectedCheckBox.includes(item.id)}
							onChange={(event) => handleCheckBox(item.id, event)}
							sx={{
								color: checkBoxColor,
								'&.Mui-checked': {
									color: checkBoxCheckedColor,
								},
							}}
						/>
						<Typography className={styles['modal-sub-text']}>
							{item.value}
						</Typography>
					</Grid>
				</Grid>
				<Grid
					item
					display="flex"
					alignItems="flex-end"
					justifyContent="flex-end"
					gap="10px"
				>
					<ButtonComp btnType="secondary" clickHandler={cancelClicked}>
						Cancel
					</ButtonComp>
					<ButtonComp
						btnType="primary"
						clickHandler={submitClicked}
						disabled={selectedCheckBox.length !== 1}
					>
						Submit
					</ButtonComp>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default MappingApprovalDailog;
